import { useEffect, useState } from 'react';
import { useAuthStore } from '../store/authStore';
import { verifyAuth } from '../api';

export function useAuth() {
  const { isAuthenticated, setAuth } = useAuthStore();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (isAuthenticated) {
      setIsLoading(false);
      return;
    }

    async function authenticate() {
      try {
        const initDataRaw = window.Telegram?.WebApp?.initData;
        if (!initDataRaw) {
          // Dev mode — skip auth
          if (import.meta.env.DEV) {
            setAuth('dev-token', { id: 0, username: 'dev', first_name: 'Developer' });
            setIsLoading(false);
            return;
          }
          throw new Error('No Telegram initData available');
        }

        const data = await verifyAuth(initDataRaw);
        setAuth(data.token, data.user);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Authentication failed');
      } finally {
        setIsLoading(false);
      }
    }

    authenticate();
  }, [isAuthenticated, setAuth]);

  return { isAuthenticated, isLoading, error };
}
